export const DISCLAIMER_URL = 'https://learn.worldforestid.org/wp-content/uploads/2025/03/Disclaimer.pdf';

export const TERMS_OF_SERVICE_URL = 'https://learn.worldforestid.org/wp-content/uploads/2025/05/Terms-of-Service.pdf ';
export const PRIVACY_POLICY_URL = 'https://learn.worldforestid.org/wp-content/uploads/2025/05/Privacy-Policy.pdf';
